import React from 'react';
import { BevPageTypes } from '../BevPageTypes';
import { FontAwesomeIcon } from '../../../utilities/iconLoader/FontAwesomeIcon';
import { useBevContext } from '../context/bevContext';
import { goToNextStep } from '../helpers/bevHelpers';
import { bevLabels } from '../constants/generalConstants';
import { getModalSelectedUnit } from '../helpers/generalHelpers';

export const ModalCardHeader = ({
  modalHeader,
  clickHandler,
}: BevPageTypes.TModalHeader) => (
  <div className="unitCardHeader">
    <p className="modal-card-title unitCardModalTitle">{modalHeader}</p>
    <button onClick={clickHandler}>
      <span className="icon">
        <FontAwesomeIcon iconClassName="FaTimes" />
      </span>
    </button>
  </div>
);
export const ModalCardContentBody = ({
  unitTypeHeader,
  unitType,
  unitNumberHeader,
  unitNumber,
}: BevPageTypes.TModalCardContentBody) => (
  <>
    <div>
      <p className="unitTypeHeading">
        <span>{unitTypeHeader}</span>
      </p>
      <p className="unitType">{unitType}</p>
    </div>
    <div>
      <p className="unitNumberHeading">
        <span>{unitNumberHeader}</span>
      </p>
      <p className="unitNumber">{unitNumber}</p>
    </div>
  </>
);

export const TModalBodyButtonSection = ({
  exitBtnLabel,
  exitClickHandler,
  rentBtnLabel,
  rentClickHandler,
}: BevPageTypes.TModalBodyButtonSection) => (
  <div className="buttonSection">
    <button className="button exitBtn" onClick={exitClickHandler}>
      {exitBtnLabel}
    </button>
    <button className="button is-highlight rentBtn" onClick={rentClickHandler}>
      {rentBtnLabel}
    </button>
  </div>
);

export const DisplayUnitModal = ({
  showModal,
  selectedUnit,
  unitTypesList,
  clickHandler,
}: BevPageTypes.TUnitModal) => {
  const selectedUnitFrom = getModalSelectedUnit(unitTypesList, selectedUnit);
  const bevContext = useBevContext();
  const { height, nextRoute, otherNavigationProps } = bevContext;
  const {
    modal: {
      mainTitle,
      unitTypeLabels,
      unitNumberLabel,
      exitBtnLabel,
      rentBtnLabel,
    },
  } = bevLabels;
  const rentUnitButtonHandler = () => {
    const navigationProps = {
      ...otherNavigationProps,
      bevData: {
        show: true,
        selectedUnitId: selectedUnit.id,
        selectedUnitLabel: selectedUnit.label,
      },
    };
    goToNextStep(nextRoute, navigationProps);
  };
  return (
    <div
      className={`modal unitCardModal py-6 ${showModal && 'is-active'}`}
      style={{
        marginTop: height,
      }}
    >
      <div className="modal-background unitCardModalBackground" />
      <div className="modal-card unitCardModalCard">
        <section className="modal-card-body">
          <ModalCardHeader
            modalHeader={mainTitle}
            clickHandler={clickHandler}
          ></ModalCardHeader>
          <ModalCardContentBody
            unitTypeHeader={unitTypeLabels}
            unitNumberHeader={unitNumberLabel}
            unitType={selectedUnitFrom[0].description}
            unitNumber={selectedUnit.label}
          ></ModalCardContentBody>
          <TModalBodyButtonSection
            exitBtnLabel={exitBtnLabel}
            rentBtnLabel={rentBtnLabel}
            exitClickHandler={clickHandler}
            rentClickHandler={rentUnitButtonHandler}
          ></TModalBodyButtonSection>
        </section>
      </div>
    </div>
  );
};
